module.exports = "/images/vendor/desiigner-svg/svg/social/youtube.svg?f65523db6b290282d92d20afac6072a3";